import { NavigationLink } from '@ui/interfaces/navigation'
import clsx from 'clsx'

interface InnerMenuProps {
  links: NavigationLink[]
}

const InnerMenuLink = ({ link }: { link: NavigationLink }) => {
  let navItem: NavigationLink
  if (typeof link === 'function') {
    const _navItem: NavigationLink | null = link()
    if (!_navItem) return null
    navItem = _navItem
  } else {
    navItem = link
  }

  if (navItem.type && navItem.type === 'header') {
    return <div className="p-3 text-sm font-medium">{navItem.name}</div>
  }

  return (
    <div
      className={clsx(
        'flex w-[12.5rem] cursor-pointer flex-row items-center gap-2 rounded-md p-3 text-xs font-medium',
        {
          'text-gray-900': !navItem.current,
          'bg-primary-100 text-primary-600': navItem.current,
        }
      )}
      onClick={navItem.onClick}>
      {
        <navItem.icon
          className={clsx('size-4 stroke-[0.085rem]', {
            'stroke-gray-900': !navItem.current,
            'stroke-primary-600': navItem.current,
          })}
        />
      }
      {navItem.name}
    </div>
  )
}

export const InnerMenu = ({ links }: InnerMenuProps) => {
  return (
    <div className="flex w-full flex-col space-y-2 border-r border-gray-200 px-3 py-4">
      {links.map((link) => (
        <InnerMenuLink key={link.name} link={link} />
      ))}
    </div>
  )
}
